<div class="group-options-container" *ngFor="let group of optionsGroups; first as firstGroup; last as lastGroup">
    <span translate class="group-label" aria-hidden="true">{{ group.labelKey }}</span>
    <div class="group-options-item-wrapper">
        <ul class="group-options-items">
            <li class="option-item" *ngFor="let option of group.options, let i = index; first as firstOption; last as lastOption">
                <dcl-option-item
                    id="checkbox-item-{{i}}"
                    [optionGroupLabel]="!firstGroup && firstOption ? group.labelKey : ''"
                    [isLastGroup]="lastGroup"
                    [isLastOption]="lastOption"
                    [option]="option"
                    (onItemChanged)="onItemChanged($event, group.type)"
                    (lastItemTabbed)="lastItemTabbed.emit($event)">
                </dcl-option-item>
            </li>
        </ul>
    </div>
</div>
